import React, { ReactElement, useEffect } from "react";
// import { WindowMediaLayout } from "../constants";
import { withChannelroomStore } from "../../utils/with-channelroom-store";
import ChannelLayoutContainer from "../ChannelLayoutContainer";
import "./index.less";
import {
    OnSelectedIconProps,
    SpecialEffect,
    SpecialEffectIconUsed,
    VideoWindowLayout,
    SpecialEffectRenderMap,
} from "remo-components";
import { VideoWindowLayoutTypes } from "remo-types/src/constants";
import { CustomType, ICustomPayload, ICustomPayloadDescription } from "@obsbot/remo-services";
import { eventBus, EventTypes } from "@obsbot/remo-utils";
import { SpecialEffectTo, useChannelRoomStore, useGlobalStore } from "@obsbot/remo-stores";
import { useParams } from "react-router-dom";
interface ChannelRoomProps {
    layoutType: VideoWindowLayoutTypes;
}

const ChannelRoomPageCom: React.FC<ChannelRoomProps> = withChannelroomStore<ChannelRoomProps>(
    ({ channelroomStore }): ReactElement => {
        if (!channelroomStore) {
            return <div></div>;
        }
        const params = useParams();
        const { userInfo } = useGlobalStore();
        const { channelSpecialList, updateSpecialList } = useChannelRoomStore();
        const { rtm, userUUID } = channelroomStore;

        useEffect(() => {
            const { toJoinRoomUUID, updateToJoinRoomUUID } = useGlobalStore.getState();
            if (toJoinRoomUUID) {
                // 延时一下不然, 容器组件还没来得及监听
                setTimeout(() => {
                    eventBus.emit("preview-camera", {
                        isPreview: true,
                    });
                }, 0);
            }
            return () => {
                updateToJoinRoomUUID("");
            };
        }, []);
        const onSelectedSpecial = async ({
            icon: ic,
            toType,
            data,
            actionID,
        }: OnSelectedIconProps): Promise<void> => {
            const icon = ic as SpecialEffectIconUsed;
            const iconData = SpecialEffectRenderMap[icon];
            let to = "";
            if (iconData) {
                let isDraw = true;
                if (toType === SpecialEffectTo.All) {
                    const messagePayload: ICustomPayload = {
                        data: icon,
                        description: ICustomPayloadDescription.ChannelInteraction,
                        extension: toType,
                    };
                    const result = await rtm?.sendRoomMessage(CustomType.Custom, messagePayload);
                    if (result === "") {
                        isDraw = false;
                    }
                    eventBus.emit("send-new-msg", {
                        userID: userInfo?.user_id || "",
                        conversationID: "GROUP" + params.roomUUID,
                    });
                } else {
                    const uid = data;
                    if (uid) {
                        const profile = await rtm?.getUserProfile([uid]);
                        if (profile && profile[0]) {
                            to = uid;
                            const primeToType = toType;
                            // @ts-ignore
                            toType = JSON.stringify({
                                toType: SpecialEffectTo.User,
                                userID: profile[0].userID,
                                userName: profile[0].nick,
                            });
                            const messagePayload: ICustomPayload = {
                                data: icon,
                                description: ICustomPayloadDescription.ChannelInteraction,
                                extension: JSON.stringify({
                                    toType: primeToType,
                                    userID: profile[0].userID,
                                    userName: profile[0].nick,
                                }),
                            };
                            const result = await rtm?.sendRoomMessage(
                                CustomType.Custom,
                                messagePayload,
                            );
                            if (result === "") {
                                isDraw = false;
                            }
                            eventBus.emit("send-new-msg", {
                                userID: userInfo?.user_id || "",
                                conversationID: "GROUP" + params.roomUUID,
                            });
                        }
                    }
                }
                isDraw &&
                    updateSpecialList([
                        ...channelSpecialList,
                        {
                            icon: iconData,
                            toType,
                            to: to,
                            sender: userUUID,
                            actionID,
                            soundEffect: icon,
                        },
                    ]);
            }
        };

        useEffect(() => {
            const replayInteractionHandler = ({
                from,
                to,
                toName,
                toType: tType,
                icon: ic,
                actionID,
            }: EventTypes["replay-interaction"]): void => {
                const icon = ic as SpecialEffectIconUsed;
                const toType = tType as SpecialEffectTo;
                if (SpecialEffectRenderMap[icon]) {
                    updateSpecialList([
                        ...channelSpecialList,
                        {
                            icon: SpecialEffectRenderMap[icon],
                            toType,
                            to,
                            toName,
                            sender: from,
                            actionID,
                            soundEffect: icon,
                        },
                    ]);
                }
            };
            eventBus.on("replay-interaction", replayInteractionHandler);
            return () => eventBus.off("replay-interaction", replayInteractionHandler);
        }, []);

        useEffect(() => {
            const handleMessageFrequently = (seconds: number): void => {
                const message = (window as any).__ReMoI18n.t("send-message-too-frequently", {
                    seconds,
                });
                eventBus.emit("show-message", {
                    message: message,
                    type: "warning",
                });
            };
            rtm?.events.on("send-message-too-frequently", handleMessageFrequently);
            return () => {
                rtm?.events.off("send-message-too-frequently", handleMessageFrequently);
            };
        }, [rtm]);

        return (
            <div className="channel-room-page">
                <VideoWindowLayout />
                <div className="channel-room-special-effect">
                    <SpecialEffect
                        showKeys={[
                            "FaceChangeIcon",
                            "TornadoIcon",
                            "WelcomeIcon",
                            "CryIcon",
                            "HeartIcon",
                            "BombIcon",
                            "SkateIcon",
                            "CelebrateIcon",
                        ]}
                        showOperateIcon={true}
                        onSelectedIcon={onSelectedSpecial}
                    />
                </div>
            </div>
        );
    },
);

export default function ChannelRoomPage(): React.JSX.Element {
    return <ChannelLayoutContainer Component={ChannelRoomPageCom} />;
}
